module.exports = __webpack_public_path__ + "img/142.9.53874933.png";